
import {PersonnelEN} from "./personnel/en";
import {ApplicationEN} from "./application/en";
import {TimeKeepingEN} from "./timekeeping/en";
import {WageEN} from "./wage/en";
import {AssetEN} from "./asset/en";

export const HRMEN = {
    contract: "Contract",
    ...PersonnelEN,
    ...ApplicationEN,
    ...TimeKeepingEN,
    ...WageEN,
    ...AssetEN
}